import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { UseFormReturn, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ImageLinksApi, ItemGroupApi } from "../../../../../../../../services/Api/Organization/types";
import { ImageLinksMode, ModalImageLinkItem } from "../../utils/types";
import ImageLinkItem from "./ImageLInks/ImageLinkItem";
import ImageLinksModal from "./ImageLInks/ImageLinksModal";

interface Props {
	form: UseFormReturn<ItemGroupApi>;
}

const ItemGroupImages = ({ form }: Props) => {
	const { t } = useTranslation();
	const { control, watch } = form;
	const { fields, update, replace } = useFieldArray({
		control,
		name: "items",
		keyName: "key",
	});
	const [modalImageLinkItem, setModalImageLinkItem] = useState<ModalImageLinkItem | undefined>(undefined);
	const watchedItems = watch("items");

	useEffect(() => {
		if (watchedItems.length !== fields.length) {
			replace(watchedItems);
		}
	}, [replace, fields, watchedItems]);

	const handleUpdateImage = (data: ImageLinksApi) => {
		if (modalImageLinkItem) {
			const currentFieldItem = watchedItems[modalImageLinkItem.index];
			update(modalImageLinkItem.index, {
				...currentFieldItem,
				...data,
				image_link: data.image?.image_data ? undefined : data.image_link,
			});
		}
		setModalImageLinkItem(undefined);
	};

	const handleClose = () => {
		setModalImageLinkItem(undefined);
	};

	const handleRemove = (index: number) => {
		update(index, { ...fields[index], image_link: undefined, image: undefined });
	};

	const handleRemoveImage = () => {
		if (modalImageLinkItem) {
			update(modalImageLinkItem.index, {
				...fields[modalImageLinkItem.index],
				image_link: undefined,
				image: undefined,
			});
		}

		setModalImageLinkItem(undefined);
	};

	return (
		<>
			<Form.Label>{t("modules.menu.field.items_images.title")}</Form.Label>
			<small className="text-muted d-block image-link__subtitle">
				{t("modules.menu.field.items_images.help_text")}
			</small>
			<Card className="image-link-card">
				<Card.Body>
					<div className="d-flex flex-wrap gap-2">
						{fields.map((field, index) => {
							const { image_link, image } = field;

							return (
								<ImageLinkItem
									handleRemove={() => handleRemove(index)}
									handleEdit={() =>
										setModalImageLinkItem({ index, modalImageLinkItem: { image_link, image } })
									}
									key={field.key}
									image={field}
									index={index}
									mode={ImageLinksMode.ADD_TO_EXISTING_FIELDS}
								/>
							);
						})}
					</div>
				</Card.Body>
			</Card>
			{modalImageLinkItem && (
				<ImageLinksModal
					handleRemove={handleRemoveImage}
					handleUpdate={handleUpdateImage}
					imageLinkItem={modalImageLinkItem.modalImageLinkItem}
					handleClose={handleClose}
				/>
			)}
		</>
	);
};

export default ItemGroupImages;
